import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { VisibilityWatcher } from "@common/visibilityWatcher";
import { Checkbox } from "@common/checkbox";

import { ReportType } from "../types";
import { ToggleArrow } from "./toggleArrow";
import { Props } from "./types";

import styles from "./styles.scss";

function ViewSelect({
  selectedReportType,
  selectDataType,
  unSelectDataType,
}: Props) {
  const { t } = useTranslation();
  const nameMap = {
    monthly: t("exportReportsPage.timeSheetByTaskReport.views.monthly"),
    weekly: t("exportReportsPage.timeSheetByTaskReport.views.weekly"),
    daily: t("exportReportsPage.timeSheetByTaskReport.views.daily"),
  };

  const isSelected = (type: ReportType) =>
    !!selectedReportType.find((dataType) => dataType === type);

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div
          className={classNames(styles.dataTypeFilter, {
            [styles.opened]: isVisible,
          })}
        >
          <div className={styles.input} onClick={isVisible ? hide : show}>
            {selectedReportType.length > 0 ? (
              <p className={styles.selectedDataTypes}>
                {selectedReportType.map((type, index) => (
                  <span key={type}>
                    {nameMap[type]}
                    {index !== selectedReportType.length - 1 ? ", " : ""}
                  </span>
                ))}
              </p>
            ) : (
              <p className={styles.placeholder}>
                {t("projectPage.listsPage.filters.show")}
              </p>
            )}
            <ToggleArrow className={styles.toggleArrow} />
          </div>
          {isVisible && (
            <div className={styles.list}>
              <div
                className={styles.item}
                onClick={() =>
                  isSelected("monthly")
                    ? unSelectDataType("monthly")
                    : selectDataType("monthly")
                }
              >
                <Checkbox isChecked={isSelected("monthly")} />
                <p className={styles.typeName}>{nameMap["monthly"]}</p>
              </div>
              <div
                className={styles.item}
                onClick={() =>
                  isSelected("weekly")
                    ? unSelectDataType("weekly")
                    : selectDataType("weekly")
                }
              >
                <Checkbox isChecked={isSelected("weekly")} />
                <p className={styles.typeName}>{nameMap["weekly"]}</p>
              </div>
              <div
                className={styles.item}
                onClick={() =>
                  isSelected("daily")
                    ? unSelectDataType("daily")
                    : selectDataType("daily")
                }
              >
                <Checkbox isChecked={isSelected("daily")} />
                <p className={styles.typeName}>{nameMap["daily"]}</p>
              </div>
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { ViewSelect };
